export default __webpack_public_path__ + "static/media/intro4.dac48076.png";